import { render, staticRenderFns } from "./Persona.vue?vue&type=template&id=7af8951d&scoped=true&"
import script from "./Persona.vue?vue&type=script&lang=js&"
export * from "./Persona.vue?vue&type=script&lang=js&"
import style0 from "./Persona.vue?vue&type=style&index=0&id=7af8951d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af8951d",
  null
  
)

export default component.exports